/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { ApricotAction } from "client/actions/modal";

export const initScreen = (setScreenInfo: ApricotAction) => {
  const { innerWidth, innerHeight } = window;

  const supportOri =
    typeof window.orientation === "number" &&
    typeof window.onorientationchange === "object";

  let isLandscape: boolean;
  const ori = (supportOri: boolean) => {
    if (supportOri) {
      isLandscape = window.orientation === 90 || window.orientation === -90;
    } else {
      isLandscape = window.innerWidth > window.innerHeight;
    }
    return isLandscape ? "landscape" : "portrait";
  };

  setScreenInfo({
    width: innerWidth,
    height: innerHeight,
    orientation: ori(supportOri),
  });

  const screenEvtHandler = () => {
    const orientation = ori(supportOri);
    let { width, height } = screen;
    if (
      (orientation === "landscape" && width < height) ||
      (orientation === "portrait" && height < width)
    ) {
      // b = [a, a = b][0];  // The way to swap a and b
      width = [height, (height = width)][0];
    }
    setScreenInfo({ width, height, orientation });
  };

  const screenEvt = supportOri ? "orientationchange" : "resize";
  window.addEventListener(screenEvt, screenEvtHandler, false);

  return { screenEvt, screenEvtHandler };
};
